import ConfigService from "../../../../src/services/config/config.service";

let facebookClientPromise: Promise<facebook.FacebookStatic> | null = null;

export async function FacebookClient(): Promise<facebook.FacebookStatic> {
  if (window["FB"]) {
    return window["FB"];
  }

  if (facebookClientPromise === null) {
    facebookClientPromise = new Promise<facebook.FacebookStatic>(res => {
      window["fbAsyncInit"] = async () => {
        const fb = window["FB"];
        fb.init({
          appId: ConfigService.getConfig().miscellaneousConfig.fbAppId,
          cookie: true,
          xfbml: true,
          version: "v3.1"
        });
        res(fb);
      };
      const script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/sdk.js";
      script.async = true;
      script.onload = window["fbAsyncInit"];
      document.body.appendChild(script);
    });
  }

  return facebookClientPromise;
}

export function facebookLoginStatus(): Promise<facebook.StatusResponse> {
  return new Promise<facebook.StatusResponse>(async res => {
    const facebookClient = await FacebookClient();
    facebookClient.getLoginStatus(res);
  });
}

export function isFacebookAuthenticated(statusResponse: facebook.StatusResponse): boolean {
  return statusResponse.status === "connected" || statusResponse.status === "authorization_expired";
}

export function loginFacebook(): Promise<facebook.StatusResponse> {
  return new Promise<facebook.StatusResponse>(async resolve => {
    const client = await FacebookClient();
    client.login(
      async response => {
        FB.api("/me", { fields: "name, email" }, data => {
          response.authResponse["email"] = data.email;
          response.authResponse["name"] = data.name;

          resolve(response);
        });
      },
      {
        scope: "public_profile,email"
      }
    );
  });
}

export function logoutFacebook(): Promise<facebook.StatusResponse> {
  return new Promise<facebook.StatusResponse>(async res => {
    await facebookLoginStatus();
    const facebookClient = await FacebookClient();
    facebookClient.logout(res);
  });
}



// WEBPACK FOOTER //
// ./src/components/common/Facebook/FacebookClient.ts